import React,{useState, useEffect}  from 'react';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import { Helmet } from "react-helmet";
function Csearching(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>search in c tutorial For Beginners</title>
 <meta name="description" content="search in c tutorial for beginners.Array in C is a collection of similar type of data and stored in manually consecutively under one name CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,C array,One-dimensional Array in C,Multi-dimensional Array in C" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-array" />
 </Helmet>
 
 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">search in c</h1>
    <div className="first">
        <a href="/csharp-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="m-4 para">This search in c means searching is used to find a particular element.
</p>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q- enter 10 elements , find an items and count how many times a number repeate search in c?
</Card.Header>
  <Card.Body>
    <Card.Text>
    void main()<br/>
    &#123;<br/>
Int a[10],I,item,count=0;<br/>
Printf(“enter 10 elements”);<br/>
For(i=0;i&#60;10;i++)<br/>
Scanf(“%d”,&#38;a[10]);<br/>
Printf(“enter item to be searched”);<br/>
Scanf(“%d”,&#38;item);<br/>
For(i=0;i&#60;10;i++)<br/>
&#123;<br/>
If (a[i]==item)<br/>
Count++;<br/>
&#125;<br/>
Printf(“item is found%d times”,count);<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer>This is a comment example search in c</Card.Footer>
</Card>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Searching in list C example</Card.Header>
  <Card.Body>
    <Card.Text>
  <p> X=[2,5,1,10,30,45,56]<br/>
If 10 in x :<br/>
Print(“element is present”)<br/>
Else:<br/>
Print(“not  present”)<br/>
 Ans- 10 is present <br/>
 </p> 
    </Card.Text>	
  </Card.Body>
  <Card.Footer>This is a literal in C  example</Card.Footer>
</Card>
<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/csharp-goto">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Csearching;